/**
 * Routes - Configuration du routage de l'application
 *
 * Utilise react-router-dom pour la navigation.
 * Tous les composants de pages viennent de presentation/components.
 *
 * NOTE: Les composants rÃ©cupÃ¨rent leurs donnÃ©es via les hooks,
 * pas via des props passÃ©es depuis App.tsx.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { Dashboard } from '../components/dashboard/Dashboard';
import { HistoryPage } from '../components/history/HistoryPage';
import { ReportsPage } from '../components/reports/ReportsPage';
import { WithdrawalPage } from '../components/withdrawal/WithdrawalPage';
import { DepositPage } from '../components/deposit/DepositPage';
import { SettingsPage } from '../components/settings/SettingsPage';

export function AppRoutes() {
  return (
    <Routes>
      {/* Page de connexion */}
     

      {/* Page d'accueil - Tableau de bord */}
      <Route
        path="/"
        element={<Dashboard />}
      />

      {/* Page des retraits */}
      <Route path="/withdrawals" element={<WithdrawalPage />} />

      {/* Page des versements */}
      <Route path="/deposits" element={<DepositPage />} />

      {/* Historique des transactions */}
      <Route path="/history" element={<HistoryPage />} />

      {/* Rapports */}
      <Route path="/reports" element={<ReportsPage />} />

      {/* ParamÃ¨tres */}
      <Route path="/settings" element={<SettingsPage />} />

      {/* Redirection par dÃ©faut */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

